import React from 'react'

import styled from 'styled-components'

const ContactDetails = styled.address`
  font-family: Cera PRO;
  line-height: 16px;
  font-size: 16px;
`

function ContactDetailsWrapper({ email, mobile, formattedMobile }) {
  const emailExists = !!email
  const mobileExists = !!mobile
  return (
    (emailExists || mobileExists) && (
      <ContactDetails>
        {mobileExists && (
          <span>
            <a href={'tel:' + mobile}>{formattedMobile}</a>
            <br />
          </span>
        )}
        {emailExists && <a href={'mailto:' + email}>{email}</a>}
      </ContactDetails>
    )
  )
}

export default ContactDetailsWrapper
